export default {"src":"/_next/static/media/CECA_Home_Icon_Phone.562652fd.svg","height":50,"width":50};